import { useCallback } from "react";
import { PageRoutes } from "../../../constants/routes";
import { useNavigation } from "../../../hooks/useNavigation";

export const useUserGuide = () => {
  const { navigateToPage } = useNavigation();

  const handleClick = useCallback(() => {
    navigateToPage(PageRoutes.CUSTOMER_INFO);
  }, []);
  return {
    handleClick,
  };
};
